<div class="container dialog-container credit-card-dialog-container d-flex flex-wrap">
  <h3>Enter Credit Card Details</h3>

  <form class="k-form w-100" #creditCardForm="ngForm" novalidate>
    <div class="mt-2">
      <kendo-label for="cardNumberInput" text="Card Number">
      </kendo-label>
      <input kendoTextBox id="cardNumberInput" name="cardNumberInput" class="k-input" [(ngModel)]="creditCardDetails.cardNumber"
        (change)="onCardNumberChange()" [pattern]="getCardNumberPattern()" required />
    </div>

    <div class="mt-2 d-flex">
      <div class="mr-auto">
        <kendo-label for="cvvNumberInput" text="CVV Number">
        </kendo-label>
        <input kendoTextBox id="cvvNumberInput" name="cvvNumberInput" class="k-input cvv-number-input" [(ngModel)]="creditCardDetails.cvvNumber"
          (change)="onCvvNumberChange()" [pattern]="getCvvNumberPattern()" required />
      </div>
  
      <div>
        <kendo-label for="expirtMonthInput" text="Expiry">
        </kendo-label>
  
        <div class="d-flex">
          <kendo-dropdownlist id="expirtMonthInput" name="expiryMonthInput" class="month-input" [(value)]="creditCardDetails.expiryMonth"
            [data]="expiryMonths" required>
          </kendo-dropdownlist>
    
          <kendo-dropdownlist id="expirtYearInput" name="expiryYearInput" class="year-input" [(value)]="creditCardDetails.expiryYear"
            [data]="expiryYears" required>
          </kendo-dropdownlist>
        </div>
      </div>
    </div>
  </form>

  <div class="d-flex flex-row-reverse mt-4 w-100">
    <button class="ms-2" kendoButton [primary]="true" [disabled]="!creditCardForm.valid" type="button" (click)="onOkClick()">
      Ok
    </button>
    <button kendoButton type="button" (click)="onCancelClick()">
      Cancel
    </button>
  </div>
</div>